import {useMutation} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {meService} from "@/src/modules/core/services/me";

import {getHouseholdOccupantErrorMessage} from "../lib/occupant-errors";
import {householdService} from "../service";
import type {InviteHouseholdOccupantRequest} from "../types/occupant";

type UseInviteHouseholdOccupantParams = {
  onSuccess?: () => void;
};

export default function useInviteHouseholdOccupant(params?: UseInviteHouseholdOccupantParams) {
  const {t} = useTranslation("households");
  const invalidate = useInvalidate("households");

  return useMutation({
    mutationFn: ({id, body}: {id: number; body: InviteHouseholdOccupantRequest}) =>
      householdService.inviteOccupant(id, body),
    retry: false,
    onSuccess: async () => {
      await meService.getMe();
      invalidate();
      toast.success(t("toast.tenant_invitation_sent", {defaultValue: "Tenant invitation sent"}), TOAST_CONFIG);
      params?.onSuccess?.();
    },
    onError: (error) => {
      toast.error(
        getHouseholdOccupantErrorMessage(
          error,
          t("toast.invite_tenant_error", {defaultValue: "Could not invite tenant. Please try again."}),
        ),
        TOAST_CONFIG,
      );
    },
  });
}
